import { v4 as createUuid } from 'uuid';
import { getCookie, saveCookie } from '../cookie/cookie-utils';
var cookieName = 'XSRF-TOKEN-GPF';
export function csrfHeader() {
    var token = getCookie(cookieName);
    if (!token) {
        var date = new Date();
        date.setSeconds(date.getSeconds() + 10);
        saveCookie(cookieName, createUuid(), date);
        token = getCookie('XSRF-TOKEN-GPF');
    }
    return {
        'X-XSRF-TOKEN': token,
    };
}
